// extracted by mini-css-extract-plugin
export default {"skipLink":"SkipLinks_skipLink__zjBZi"};